export default "__VITE_ASSET__DEI6QyKs__"